module.exports = __webpack_public_path__ + "img/flavor_orange.bbbe0e31.png";